export default {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1.6,
    px: 3,
    backgroundColor: 'background.white',
    color: 'white',
    height: '64px',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  title: {
    ml: 2.5,
    color: 'text.grey.blue_2',
  },
  iconButton: {
    color: 'text.dark',
  },
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'black',
    pl: 1,
    pr: 1.5,
    borderRadius: 2,

    '& > svg': {
      height: 39,
      width: 100,
    },
  },
  logoImage: {
    height: 39,
  },
  userInfo: {
    mr: 2,
    color: 'text.dark',
  },
};
